module.exports = __webpack_public_path__ + "img/sponsor-3.cc9fd68a.jpg";